// extracted by mini-css-extract-plugin
export default {"types":"storage-type-section_types__NhtMl","type":"storage-type-section_type__bFuTO"};